import type { ExportVersion } from '@/api/hooks/useAccountantExports';

export function ExportCover({ version }: { version: ExportVersion }) {
  const unresolved = version.unresolved.open_items;
  return (
    <div className="rounded-[10px] border border-border bg-card p-5" data-testid="export-cover">
      <p className="text-[11px] uppercase tracking-wide text-muted-foreground">Version {version.version} · {version.taxonomy_version}</p>
      <h2 className="mt-2 text-lg font-semibold">Tax year export package</h2>
      <dl className="mt-4 grid grid-cols-2 gap-3 text-sm desktop:grid-cols-4">
        <div><dt className="text-muted-foreground">Rows</dt><dd className="font-mono">{version.row_count}</dd></div>
        <div><dt className="text-muted-foreground">Unresolved</dt><dd className="font-mono">{unresolved}</dd></div>
        <div><dt className="text-muted-foreground">Created</dt><dd>{new Date(version.created_at).toLocaleDateString()}</dd></div>
        <div><dt className="text-muted-foreground">Snapshot</dt><dd className="truncate font-mono" title={version.snapshot_sha256}>{version.snapshot_sha256.slice(0, 12)}…</dd></div>
      </dl>
      {unresolved > 0 && <p className="mt-4 rounded-md bg-degraded-surface p-3 text-sm text-degraded-foreground">{unresolved} unresolved items are included in the cover. They do not block download or filing; review them with the preparer.</p>}
      <p className="mt-4 text-xs text-muted-foreground">Records only. Not tax advice. We do not file.</p>
    </div>
  );
}
